// D-213 — the ONE search rule of the app. It mirrors app.fn_report_search_match (migration 0141)
// exactly: the query is trimmed; blank matches everything; otherwise a case-insensitive substring
// match against ANY of the given fields (a company's name or its tax id). Lives in the ui
// foundation so the shared Select can use it; lib/search.ts re-exports it for feature code.

export function normalizeSearch(query: string): string {
  return query.trim();
}

export function matchesSearch(query: string, ...fields: readonly (string | null | undefined)[]): boolean {
  const q = normalizeSearch(query).toLowerCase();
  if (q === '') return true;
  return fields.some((f) => (f ?? '').toLowerCase().includes(q));
}
